import unionAxios from "@/utils/union-axios";

/**
 * 获取用户信息
 */
export const previewDetails = (params) => {
  return unionAxios.post(`/web-h5/charge/marketingH5Page/preview`, params);
};

/**
 * 获取页面预览配置
 */
export const previewDetailsV2 = (params) => {
  return unionAxios.post(
    `/web-h5/charge/marketingH5Page/findPageConfig`,
    params,
  );
};

/**
 * 获取领奖信息
 */
export const batchWelfareByUid = (params) => {
  return unionAxios.post(
    `/web-h5/charge/marketingHomepage/batchWelfareByUid`,
    params,
  );
};

/**
 * 领取奖品
 */
export const receivePrize = (params) => {
  return unionAxios.post(`/web-h5/charge/marketingHomepage/claim`, params);
};

/**
 * 获取活动详情
 */
export const getActivityInfo = (params) => {
  return unionAxios.post(
    `/web-h5/charge/lotteryActivity/lotteryActivityList`,
    params,
  );
};

/**
 * 进行抽奖
 */
export const userPrizeDraw = (params) => {
  return unionAxios.post(
    `/web-h5/charge/lotteryActivity/userPrizeDraw`,
    params,
  );
};

/**
 * 走马灯列表
 */
export const trottingHorseLamp = (params) => {
  return unionAxios.post(
    `/web-h5/charge/lotteryActivity/trottingHorseLamp`,
    params,
  );
};

/**
 * 用户打开分享
 */
export const userShareTask = (params) => {
  return unionAxios.post(`/web-h5/charge/userShare/userShareTask`, params);
};

/**
 * 批量查询充电累计活动参与情况
 */
export const batchCumulateByUid = (params) => {
  return unionAxios.post(
    `/web-h5/charge/marketingHomepage/batchCumulateByUid`,
    params,
  );
};

/**
 * 查询中奖列表
 */
export const winningRecord = (params) => {
  return unionAxios.post(
    `/web-h5/charge/lotteryActivity/winningRecord`,
    params,
  );
};

/**
 * 查询中奖信息
 */
export const getBenefitInfo = (params) => {
  return unionAxios.post(`/web-h5/charge/benefit/info`, params);
};

/**
 * 查询附近充电站列表
 */
export const findNearByStationV2 = (params) => {
  return unionAxios.post(
    `/web-h5/charge/station/search/findNearByStationV2`,
    params,
  );
};

/**
 * 获取指定站点列表
 * @param params 查询参数 { stationIds: string[] }
 */
export const queryStationList = (params) => {
  return unionAxios.post(
    `/web-h5/charge/station/search/queryStationList`,
    params,
  );
};

/**
 * 会员等级信息响应接口
 */
export interface MembershipLevelResponse {
  carVoltageType: number; // 会员车电压类型，0-低压，1-高压
  currentMonthBookingTimes: number; // 本月已使用预约次数
  hasBookingTimes: boolean; // 是否还有预约次数
  invTime: string; // 会员失效时间
  level: number; // 会员等级
  levelProtected: boolean; // 是否等级保护中
  member: boolean; // 是否会员
  memberType: number; // 会员开通身份，0-非车主开通，1-车主开通
  memberTypeSeg: number; // 会员身份(细分) 1-高压车主会员,2-普通车主会员,3-非车主会员
  monthlyBookingLimitMap: Record<string, number | null>; // 各等级每月预约限制，null代表无限制
  powerValueSum: number; // 近X天电力值
  protectionEndTime: string; // 等级保护截止时间
}

/**
 * 权益项接口
 */
export interface PrivilegeItem {
  levelName: string; // 等级名称，如"高压小鹏车主V2等级专享"
  levelType: string; // 等级类型
  monthlyQuota: number; // 每月预约次数配额，-1表示无限制
  usedCount: number; // 本月已使用次数
  remainingCount: number; // 剩余次数，-1表示无限制
  isCurrentLevel: boolean; // 是否为当前用户等级
}

/**
 * 获取用户会员等级信息
 */
export const getUserMembershipLevel = (): Promise<{
  code: number;
  data: MembershipLevelResponse;
  message?: string;
}> => {
  return unionAxios.post(
    `/xp-charge-boot/mini/charge/member/getUserMembershipLevel`,
    {},
  );
};

/**
 * 将 API 响应转换为权益卡片数据
 * @param response 会员等级 API 响应
 * @returns 权益卡片列表和当前等级索引
 */
export const transformToPrivilegeList = (
  response: MembershipLevelResponse,
): { privileges: PrivilegeItem[]; currentLevelIndex: number } => {
  const {
    monthlyBookingLimitMap,
    currentMonthBookingTimes,
    carVoltageType,
    level,
  } = response;

  if (!monthlyBookingLimitMap) {
    return { privileges: [], currentLevelIndex: -1 };
  }

  const voltageText = carVoltageType === 1 ? "高压" : "低压";

  // 按等级排序
  const sortedEntries = Object.entries(monthlyBookingLimitMap).sort(
    ([a], [b]) => Number(a) - Number(b),
  );

  let currentLevelIndex = -1;

  const privileges = sortedEntries.map(([levelKey, quota], index) => {
    const isCurrentLevel = levelKey === String(level);
    if (isCurrentLevel) {
      currentLevelIndex = index;
    }

    const monthlyQuota = quota ?? -1; // -1 表示无限制
    const usedCount = isCurrentLevel ? currentMonthBookingTimes : 0;
    const remainingCount =
      monthlyQuota === -1 ? -1 : Math.max(0, monthlyQuota - usedCount);

    return {
      levelName: `${voltageText}小鹏车主V${levelKey}等级专享`,
      levelType: levelKey,
      monthlyQuota,
      usedCount,
      remainingCount,
      isCurrentLevel,
    };
  });

  return { privileges, currentLevelIndex };
};
